import { cookiePersistStorage } from "@/helper/common.helper";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import {
  IBulkSuccess,
  ICheckGeneratorResponse,
  IPauseUnNecessaryQrCodes,
  UseIsChangedType,
  UseQrShowType,
  IQRSingleItem,
  IButtonColor,
  IButtonPrimaryColor,
  DownloadQrDesktopStateType,
} from "@/types/stateTypes";
import { defaultFileFormatDesktop, defaultFileSize } from "@/constant";

export const useQrShowState = create(
  persist<UseQrShowType>(
    (set, get) => ({
      qrShowId: null,
      downloadQr: false,
      downloadQrId: null,
      qrCodeLoading: false,
      dashboardQr: null,
      removeQrData: (key: string) => {
        const currentState = get();
        if (currentState.dashboardQr && key in currentState.dashboardQr) {
          const updatedDashboardQr = { ...currentState.dashboardQr };
          delete updatedDashboardQr[key];

          set((prevState) => ({
            ...prevState,
            dashboardQr: updatedDashboardQr,
          }));
        }
      },
      insertQrData: (key: string, value: any) => {
        const currentState = get();
        const updatedDashboardQr = {
          ...currentState.dashboardQr,
          [key]: value,
        };

        set((prevState) => ({
          ...prevState,
          dashboardQr: updatedDashboardQr,
        }));
      },
      removeDashboardQr: () => {
        set({ dashboardQr: null });
      },
      setDashboardQr: (dashboardQr) => {
        dashboardQr.svgContent = "";
        set((state) => ({
          ...state,
          dashboardQr: dashboardQr,
        }));
      },

      setDownloadQrId: (val) => {
        set({
          downloadQrId: val,
        });
      },
      setQrLoading: (val) => {
        set({
          qrCodeLoading: val,
        });
      },
      setQrShowId: (val) => {
        set({
          qrShowId: val,
        });
      },
      destroyDashboardQr: () => {
        set({
          qrShowId: null,
          dashboardQr: null,
          downloadQrId: null,
          downloadQr: true,
          qrCodeLoading: false,
        });
      },
    }),
    {
      name: "useDashboardQrState",
      storage: createJSONStorage(() => cookiePersistStorage),
    },
  ),
);

export const useIsChanged = create<UseIsChangedType>((set) => ({
  isChangedValue: false,
  setIsChanged: (val) => {
    set({
      isChangedValue: val,
    });
  },
}));

export const usePauseUnNecessaryQrCodes = create<IPauseUnNecessaryQrCodes>((set) => ({
  pauseUnnecessaryConfig: {
    open: false,
    limit: 0,
  },
  setPauseUnnecessaryConfig: ({ open, limit }) => {
    set((prevState) => ({
      ...prevState,
      pauseUnnecessaryConfig: {
        ...prevState.pauseUnnecessaryConfig,
        open,
        limit,
      },
    }));
  },
}));

export const useCheckGeneratorResponse = create(
  persist<ICheckGeneratorResponse>(
    (set) => ({
      status: false,
      setStatus: (val) => {
        set({
          status: val,
        });
      },
      destroyStatus: () => {
        set({
          status: false,
        });
      },
    }),
    {
      name: "useCheckGenerateStatus",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useBulkSuccess = create<IBulkSuccess>((set) => ({
  bulkStatus: false,
  bulkError: null,
  setBulkStatus: (val) => {
    set({
      bulkStatus: val,
    });
  },
  setBulkError: (val) => {
    set({
      bulkError: val,
    });
  },
}));

export const useQrItem = create<IQRSingleItem>((set) => ({
  qrItem: null,
  setQrItem: (val) => {
    set({ qrItem: val });
  },
}));

export const useButtonColor = create<IButtonColor>((set) => ({
  buttonColorDefault: "",
  setButtonColor: (val) => {
    set({
      buttonColorDefault: val,
    });
  },
}));

export const useButtonPrimaryColor = create<IButtonPrimaryColor>((set) => ({
  buttonPrimaryColorDefault: "",
  setButtonPrimaryColor: (val) => {
    set({
      buttonPrimaryColorDefault: val,
    });
  },
  clean: () => {
    set({
      buttonPrimaryColorDefault: "",
    });
  },
}));

export const useDownloadQrDesktopStore = create<DownloadQrDesktopStateType>((set) => ({
  selectedFormat: defaultFileFormatDesktop,
  selectedFileSize: defaultFileSize,
  hasFileSize: false,
  setSelectedFormat: (val) => {
    set({
      selectedFormat: val,
    });
  },
  setSelectedFileSize: (val) => {
    set({
      selectedFileSize: val,
    });
  },
  setHasFileSize: (val) => {
    set({
      hasFileSize: val,
    });
  },
  destroyDownloadQrDesktopStore: () => {
    set({
      selectedFormat: defaultFileFormatDesktop,
      selectedFileSize: defaultFileSize,
      hasFileSize: false,
    });
  },
}));
